import { BASE_CLASS_PREFIX } from '../base/constants';

const cssClasses = {
    PREFIX: `${BASE_CLASS_PREFIX}-colorPicker`,
};

const strings = {

};

export { cssClasses };
